module.exports = __webpack_public_path__ + "static/media/ic_close.8c656d5a.svg";